export const EQUIPMENT_CATEGORY_CROPS = "Crops";
export const EQUIPMENT_CATEGORY_LIVESTOCK = "Livestock";
export const EQUIPMENT_CATEGORY_VEHICLES = "Vehicles";
export const EQUIPMENT_CATEGORY_GENERAL = "General";

export const EQUIPMENT_CATEGORIES = [
  EQUIPMENT_CATEGORY_CROPS,
  EQUIPMENT_CATEGORY_LIVESTOCK,
  EQUIPMENT_CATEGORY_VEHICLES,
  EQUIPMENT_CATEGORY_GENERAL,
];

export const EQUIPMENT_CONDITION_NEW = "New";
export const EQUIPMENT_CONDITION_EXCELLENT = "Excellent";
export const EQUIPMENT_CONDITION_GOOD = "Good";
export const EQUIPMENT_CONDITION_FAIR = "Fair";
export const EQUIPMENT_CONDITION_POOR = "Poor";

export const EQUIPMENT_CONDITIONS = [
  EQUIPMENT_CONDITION_NEW,
  EQUIPMENT_CONDITION_EXCELLENT,
  EQUIPMENT_CONDITION_GOOD,
  EQUIPMENT_CONDITION_FAIR,
  EQUIPMENT_CONDITION_POOR,
];

export const EQUIPMENT_TERM_NET_30_DAYS = "Net 30 Days";
export const EQUIPMENT_TERM_NET_60_DAYS = "Net 60 Days";

export const EQUIPMENT_TERMS = [EQUIPMENT_TERM_NET_30_DAYS, EQUIPMENT_TERM_NET_60_DAYS];

export const DEBT_SCHEDULE_PURPOSE_LIST = ["Operation", "Equipment", "Capital", "Other"];
export const DEBT_SCHEDULE_CATEGORIES = ["Crops", "Equipment", "Livestock", "Real Estate", "Vehicles", "Other"];

export const DEBT_SCHEDULE_PAYMENT_FREQUENCIES = [
  "Weekly",
  "Bi-weekly",
  "Monthly",
  "Quarterly",
  "Semi-Annual",
  "Annual",
];
export const DEBT_SCHEDULE_DAY_COUNT_CONVENTIONS = ["Actual/365"];
